import { render, staticRenderFns } from "./ContentToPrint.vue?vue&type=template&id=6ef49cda&"
import script from "./ContentToPrint.vue?vue&type=script&lang=js&"
export * from "./ContentToPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports